import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { map, of, switchMap } from "rxjs";

import { selectUserIdClaim } from "../store/authentication";
import { AppState } from "../store/store";

export const CURRENT_USER = "CURRENTUSER";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private store = inject<Store<AppState>>(Store);

  users$ = this.store.select(state => state.user.users);

  getUserName(id: string) {
    return this.store.select(selectUserIdClaim).pipe(
      switchMap(userIdClaim => {
        if (id === CURRENT_USER || id === userIdClaim) {
          return of("you");
        }
        return this.users$.pipe(
          map(users => {
            if (users) {
              const user = users.find(u => u.id === id);
              return user ? user.name : "unknown";
            }
            return "unknown";
          })
        );
      })
    );
  }
}
